import { __assign, __rest } from "tslib";
import React, { useState } from 'react';
import { Waypoint } from 'react-waypoint';
/** Only renders its children when the component is in view.
 *  Pass in react-waypoint Waypoint props. */
var RendersChildrenWhenInViewport = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    return (React.createElement(Waypoint, __assign({ onEnter: function () { return setIsVisible(true); }, onLeave: function () { return setIsVisible(false); } }, props), isVisible ? children : null));
};
RendersChildrenWhenInViewport.displayName = 'RendersChildrenWhenInViewport';
export default RendersChildrenWhenInViewport;
//# sourceMappingURL=RendersChildrenWhenInViewport.js.map